export default "__VITE_ASSET__BrKEAidI__"